import {tWithHtml} from '../../../../../../common/helpers/react/text/tWithHtml';
import {DefaultTableCheckboxModeProps} from '../../../../common/components/table/DefaultTable';

export type LockAgentsModalProps = DefaultTableCheckboxModeProps & {
    lock: boolean;
}

export default function LockAgentsModal(props: LockAgentsModalProps) {
    return (
        <p>
            {tWithHtml(props.lock ? 'LOCK_X_AGENTS' : 'UNLOCK_X_AGENTS', {count: props.checkedRows?.length ?? 0})}
        </p>
    );
}
